import { composeAPI } from "../Common/api";
import policyRateComposition from "./composition";

export const composedAPI = composeAPI(policyRateComposition);
